module.exports = __webpack_public_path__ + "static/media/Icons_25 nov-12.5ae62f04.svg";